import api from './api';

const d = (r) => r.data;
export const dspAPI = (platform = false) => {
  const B = platform ? '/api/platform/dsp' : '/api/dsp';
  return {
    registers: () => api.get(`${B}/registers`).then(d),
    register: (reg) => api.get(`${B}/registers/${reg}`).then(d),
    outstanding: () => api.get(`${B}/outstanding`).then(d),
    doc: (name) => api.get(`${B}/docs/${name}`).then(d),
    evidence: () => api.get(`${B}/evidence`).then(d),
    evidenceBlob: (id) => api.get(`${B}/evidence/${id}/download`, { responseType: 'blob' }).then(d),
    pack: () => api.get(`${B}/evidence-pack`, { responseType: 'blob' }).then(d),
    gates: (org) => api.get(platform ? `/api/platform/dsp/production-gates/${org}` : '/api/dsp/production-gates').then(d),
    // platform-only edits
    add: (reg, body) => api.post(`/api/platform/dsp/registers/${reg}`, body).then(d),
    edit: (reg, id, body) => api.put(`/api/platform/dsp/registers/${reg}/${id}`, body).then(d),
    remove: (reg, id) => api.delete(`/api/platform/dsp/registers/${reg}/${id}`).then(d),
    advance: (id, note) => api.post(`/api/platform/dsp/registers/incidents/${id}/advance`, { note }).then(d),
    addEvidence: (form) => api.post('/api/platform/dsp/evidence', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(d),
  };
};

export const connAPI = {
  get: () => api.get('/api/ato-connection').then(d),
  practice: (body) => api.put('/api/ato-connection/practice', body).then(d),
  ssid: (reason) => api.post('/api/ato-connection/software-id', { reason }).then(d),
  attest: (notified_on) => api.post('/api/ato-connection/attest', { notified: true, notified_on }).then(d),
  serviceAuth: (sid, status) => api.put(`/api/ato-connection/service-authorisations/${sid}`, { status, source: 'manual' }).then(d),
  clientAuths: (cid) => api.get(`/api/ato-connection/clients/${cid}/authorisations`).then(d),
  setClientAuth: (cid, sid, status) => api.put(`/api/ato-connection/clients/${cid}/authorisations/${sid}`, { status }).then(d),
};

export const platformAPI = {
  subs: () => api.get('/api/platform/dsp/subscriptions').then(d),
  setStatus: (org, body) => api.post(`/api/platform/dsp/subscriptions/${org}/status`, body).then(d),
  provider: () => api.get('/api/platform/dsp/provider').then(d),
  saveProvider: (body) => api.put('/api/platform/dsp/provider', body).then(d),
  gateItem: (org, sid, item, body) => api.put(`/api/platform/dsp/production-gates/${org}/${sid}/${item}`, body).then(d),
  resetGates: (org) => api.post(`/api/platform/dsp/production-gates/${org}/reset`).then(d),
};

export const saveBlob = (blob, name) => { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); };
